const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Xin chào',
    'Ref: Page content body': 'Khi đến nơi và đi, hãy nhớ nhớ quét xe buýt mã QR của bạn',
  },
};
export default labels;
